import * as yup from "yup";
import { IOrder } from "../../../entities/manhattan/order/types";
import { orderSchema } from "./orderSchema";

export default class OrderValidator {

  public static async validate(order: IOrder): Promise<boolean> {
    try {
      await orderSchema.validate(order, { abortEarly: false });
      return true;
    } catch (error: unknown) {
      if (error instanceof yup.ValidationError) {
        console.error("Validation errors:", error.errors);
      } else {
        console.error("Unexpected error:", error);
      }
      return false;
    }
  }

}
